import * as moment from "moment";

export class ParseHelper {
    /**
     * Copy object without reference.
     * @param obj boject bo be copied.
     * @returns the copied object
     */
    public static DeepCopy(obj: any): any {
        const objStr: string = JSON.stringify(obj);
        const parsedObj: any = JSON.parse(objStr);
        return parsedObj;
    }

    public static DeepCopyTree(obj: any): any {
        const objStr: string = stringifyWithTree(obj);
        const parsedObj: any = JSON.parse(objStr);
        return parsedObj;
    }
}

export function getCircularReplacer() {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };

};

export function stringifyWithTree(obj) {
    let cache = [];
    let str = JSON.stringify(obj, function (key, value) {
        if (typeof value === "object" && value !== null) {
            if (cache.indexOf(value) !== -1 && key != 'operator') {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
        return value;
    });
    cache = null; // reset the cache
    return str;
}

export class TimeConvert {
    public static transform(seconds: number): string {
        let totalTimeInSeconds = seconds ? Math.round(seconds) : 0;
        let hours = Math.floor(totalTimeInSeconds / 3600);
        let mins = Math.floor((totalTimeInSeconds % 3600) / 60);
        let secnds = Math.floor((totalTimeInSeconds % 3600) % 60);
        let result = (hours > 0 ? hours : 0).toString().padStart(2, '0') + ":" + (mins > 0 ? mins : 0).toString().padStart(2, '0') + ":" + (secnds > 0 ? secnds : 0).toString().padStart(2, '0') + " hr";
        return result;
    }
}
